module.exports = __webpack_public_path__ + "static/media/Terms and conditions pending.494e97e6.pdf";